import { Observable, of } from 'rxjs';
import { inject } from '@angular/core';
import { CoordinatesModel } from '@core';
import { UserService } from '@profile/infra';
import { map } from 'rxjs/operators';

export class UpdateUserLocationCommandHandler {
  private readonly userService: UserService = inject(UserService);

  updateLocation(coordinates: CoordinatesModel | null): Observable<void> {
    if (!coordinates) {
      return of(void 0);
    }

    return this.userService.updateLocation({ coordinates }).pipe(map(() => void 0));
  }
}
